export const fmt$ = (n) => Number(n || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

// "123 Main St · $350,000 · buyer", else the client names, else the id tail.
export const dealLabel = (t) => {
  const where = t.property_address?.street || t.buyer_names || t.seller_names || `Deal ${String(t.transaction_id).slice(-6)}`;
  return `${where} · ${fmt$(t.contract_price)} · ${t.side}`;
};
